import { each } from "lodash";

import { moveItemAndDescendants } from "./moveItemAndDescendants";

export const moveItemsAndDescendants = (
  inItemsById,
  calendar,
  newDatesById,
  spanChange,
  autoAdjustLevel,
  changePreferredPrecision = false
) => {
  // The live state we will update as we proceed
  let itemsById = inItemsById;
  let movedIds = [];

  each(newDatesById, (newDate, processId) => {
    // Move the item, and if required, its children, and re-calculate its super dates all at once
    const moveResult = moveItemAndDescendants(
      itemsById,
      processId,
      newDate,
      spanChange,
      calendar,
      autoAdjustLevel,
      changePreferredPrecision
    );
    itemsById = moveResult.itemsById;
    movedIds.push(...moveResult.movedIds);
  });

  return { itemsById, movedIds };
};
